import type { GetLocationResponse } from "@/openapi/generated";
import { buildGoogleMapsSearchQuery } from "@/lib/utils/googleMaps";

/**
 * Multi-line address for display (US-style: street lines + city, ST zip).
 */
export function formatLocationAddressLines(
  loc: Pick<
    GetLocationResponse,
    "addressLine1" | "addressLine2" | "addressLine3" | "city" | "zipCode"
  >,
): string[] {
  const lines: string[] = [];
  if (loc.addressLine1?.trim()) lines.push(loc.addressLine1.trim());
  if (loc.addressLine2?.trim()) lines.push(loc.addressLine2.trim());
  if (loc.addressLine3?.trim()) lines.push(loc.addressLine3.trim());
  const cityZip = [loc.city?.trim(), loc.zipCode?.trim()].filter(Boolean).join(" ");
  if (cityZip) lines.push(cityZip);
  return lines;
}

export function formatLocationAddressSingleLine(
  loc: Pick<
    GetLocationResponse,
    "addressLine1" | "addressLine2" | "addressLine3" | "city" | "zipCode"
  >,
): string {
  return formatLocationAddressLines(loc).join(", ");
}

/** Non-empty query for map search, or null if we don’t have enough address data. */
export function getLocationMapQuery(loc: GetLocationResponse): string | null {
  const q = buildGoogleMapsSearchQuery({
    addressLine1: loc.addressLine1,
    addressLine2: loc.addressLine2,
    addressLine3: loc.addressLine3,
    city: loc.city,
    zipCode: loc.zipCode,
    name: loc.name,
  });
  if (q) return q;
  return loc.name?.trim() ? loc.name.trim() : null;
}
